import type { InsurancePolicyModel } from "@/api/cle-api";

import {
  getCleFieldValidationState,
  getUnmatchedFailingFields,
  type CleFieldValidationState,
} from "@/components/pages/person/id/Efteruddannelse/utils/cleFieldValidation";

/** See the note on COURSE_CERTIFICATE_FIELD_KEYS in validationFieldStatus.ts. */
export const INSURANCE_POLICY_FIELD_KEYS = [
  "insuranceCompany",
  "policyStartDate",
  "lawyerLiabilityAmount",
  "guaranteeAmount",
] as const;

type InsurancePolicyFieldKey = (typeof INSURANCE_POLICY_FIELD_KEYS)[number];

export const getInsurancePolicyValidationFieldStatus = (
  policy: InsurancePolicyModel,
): Record<InsurancePolicyFieldKey, CleFieldValidationState> => {
  const { fieldValidation } = policy;

  return Object.fromEntries(
    INSURANCE_POLICY_FIELD_KEYS.map((key) => [
      key,
      getCleFieldValidationState(fieldValidation, key),
    ]),
  ) as Record<InsurancePolicyFieldKey, CleFieldValidationState>;
};

export const getInsurancePolicyUnmatchedFailingFields = (
  policy: InsurancePolicyModel,
) =>
  getUnmatchedFailingFields(
    policy.fieldValidation,
    INSURANCE_POLICY_FIELD_KEYS,
  );
